import './footer.scss';
import AOS from 'aos';
export default () => {
  $('.js-scroll-top').click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 600);
    return false;
  });
  AOS.init({
    once: 'true'
  });
};